import React, { useState, Fragment, useEffect } from 'react';
import { Grid, Container, Button, Paper } from '@material-ui/core';
import { useAddonStyle } from './useAddonStyle';

function MyEirRecurringAddons() {
    const classes = useAddonStyle();
    return (
        <Fragment>
            <Container>
                <Grid container spacing={2} className='profileMargin'>
                    <Grid item xs={12} sm={7}>
                        <h2>Recurring add ons</h2>
                        <p>
                            Select a recurring Add-on and we’ll add it for you automatically every 4
                            weeks. You can cancel them at any time.
                        </p>
                    </Grid>
                    <Grid item xs={12} sm={5}>
                        <div className='mobileFloat'>
                            <img
                                className='addonImg'
                                src='/opencms/export/system/modules/my.portal.opencms/myeir_ion/images/my-eir-add-on-recurring.png'
                            ></img>
                        </div>
                    </Grid>
                </Grid>
                <Grid container spacing={2} className='profileMargin'>
                    <Grid item xs={12} sm={6}>
                        <Paper className={classes.paper + ' ' + 'boxLayout '}>
                            <p>10GB Recurring Data Add-on</p>
                            <h3>€9.99</h3>

                            <p className='freeText'>
                                <span className='iconLayout'>
                                    {' '}
                                    <img src='/opencms/export/system/modules/my.portal.opencms/myeir_ion/images/my-eir-text.png'></img>
                                </span>
                                Freetext <span>DATA10GB</span> to <span>50104</span>
                            </p>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Paper className={classes.paper + ' ' + 'boxLayout marginLeft'}>
                            <p>1GB Recurring Data Add-on</p>
                            <h3>€5.99</h3>

                            <p className='freeText'>
                                <span className='iconLayout'>
                                    {' '}
                                    <img src='/opencms/export/system/modules/my.portal.opencms/myeir_ion/images/my-eir-text.png'></img>
                                </span>
                                Freetext<span> SUB INTERNET 1GB</span> to <span>50104</span>
                            </p>
                        </Paper>
                    </Grid>
                </Grid>
            </Container>
        </Fragment>
    );
}
export default MyEirRecurringAddons;
